import { render } from "./config-bar-g6.vue?vue&type=template&id=1ac0fb48&scoped=true"
import script from "./config-bar-g6.vue?vue&type=script&lang=js"
export * from "./config-bar-g6.vue?vue&type=script&lang=js"

import "./config-bar-g6.vue?vue&type=style&index=0&id=1ac0fb48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac0fb48"]])

export default __exports__